import React from "react";

export enum ButtonType {
    normal,
    danger,
    transparentBg,
    disabled
}

type UiButtonType = {
    className?: string,
    icon?: string,
    iconClassName?: string,
    iconOnRight?: boolean,
    onClick?: () => void,
    text?: string
    type?: ButtonType,
    stopPropagation?: boolean
}

export const UiButton: React.FC<UiButtonType> = (
    {
        className = "",
        icon,
        iconClassName,
        iconOnRight = false,
        onClick,
        text,
        type = ButtonType.normal,
        stopPropagation = true
    }) => {
    
    function getButtonStyleFromType(type: ButtonType): string {
        switch (type) {
            case ButtonType.danger:
                return " bg-danger hover:bg-danger-hover cursor-pointer"
            case ButtonType.transparentBg:
                return " border border-solid border-white hover:bg-transparent-black cursor-pointer"
            case ButtonType.disabled:
                return " bg-darkpurple-blue cursor-not-allowed"
            default:
                return " bg-purple-blue hover:bg-purple-blue-hover cursor-pointer"
        }
    }

    return (
        <div 
            className={(className ? `${className} ` : "") + "h-11 w-auto px-3 py-2.5 flex justify-center " +
                "rounded-xl transition duration-150 ease-in-out " +
                (iconOnRight ? "flex-row-reverse" : "") +
                getButtonStyleFromType(type)}
            onClick={(e) => {
                if (stopPropagation) {
                    e.stopPropagation();
                }
                
                if (onClick) {
                    onClick();
                }
            }}
            role="button"
        >
            {icon && <img
                    className={(text ? "pr-2" : "") + (iconClassName ? ` ${iconClassName}` : "")}
                    src={`/icons/${icon}.svg`}
                    alt={icon}
                />}
            
            {text && <>{text}</>}
        </div>
    )
}
